module.exports = __webpack_public_path__ + "img/decline.acb723ad.svg";